import React from "react";
import ListeDemandesCompteurTable from "./ListeDemandesCompteurTable";
const ListeDemandesCompteur = () => {
	return (
		<div className="dashboard-admin-component">
			<div className="container-dashboard-page bg-white p-3">
				<div className="col-left-dashboard col-left-dashboard-responsive mb-3">
					<div className="">
						<ListeDemandesCompteurTable />
					</div>
				</div>
			</div>
		</div>
	);
};

export default ListeDemandesCompteur;
